import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import VpnSection from "./components/VpnSection";
import CleanerSection from "./components/CleanerSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="font-sans antialiased">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <VpnSection />
      <CleanerSection />
      <ContactSection />
    </div>
  );
}
